// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"apiKey_mainHeading__2Q4Gt","fieldWrapper":"apiKey_fieldWrapper__3sDlw","label":"apiKey_label__JcFIO","buttonWrapper":"apiKey_buttonWrapper__1GfIy"};